<template>
    <div class="row col-lg-12" style="padding-left: 0px;">
        <div class="col-lg-12 mb-3">
            <a v-b-toggle.address-fill-collapse class="collapse-link">Use Address Auto Fill </a>
        </div>
        <b-collapse :visible="visible" id="address-fill-collapse" class="col-lg-12 row">
            <div
            v-if="form"
            v-for="(addressField, index) in addressApiFields"
            :class="{
            'col-md-2': addressField.type == 'button',
            'col-md-6': addressField.type != 'button',
            }"
            >
    
                <b-button  v-if="addressField.type == 'button'"
                variant="primary"
                :class="{
                    'mr-3': true,
                    'disabled': loading
                }"
                           class="fetchBtn"
                :disabled="loading || (addressField.allowedClick && !addressField.allowedClick())"
                @click="addressField.onClick">
                    <span v-if="!loading" style="opacity: 1;" class="btn-text" >{{ addressField.title }}</span>
                    <span v-else class="loader"></span>
                </b-button>
                <component v-else
                    :is="addressField.type"
                    :field="addressField"
                    :data-segment-id="dataSegmentId"
                ></component>
            </div>
            <div class="col-lg-12 mb-1 mt-3">
                <h5 class="text-muted">Or Enter Manually</h5>
            </div>
        </b-collapse>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import TextField from '@/components/registration/TextField.vue'
import axios from 'axios'

const apiBaseUrl = process.env.VUE_APP_API_URL;


export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        TextField,
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        fields: {
            type: Array
        },
        checkAddressExists:{
            type: Boolean,
            default: false,
        }
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            configData: [],
            showAddressFeature: process.env.VUE_APP_AUTO_ADDRESS_FILL == 'true',
            allowAddressReset: false,
            visible:true,
            addressApiFields: [
                {
                    _id: "house_no",
                    key: "house_no",
                    type: 'text-field',
                    label: "House Number",
                    isRequired: false,
                    minLength: 1,
                    maxLength: 100,
                    placeholder: "Enter House Number",
                },
                {
                    _id: "post_code",
                    key: "post_code",
                    type: 'text-field',
                    label: "Post Code",
                    isRequired: false,
                    minLength: 1,
                    maxLength: 100,
                    placeholder: "Enter Post Code",
                },
                {
                    _id: "submit_address",
                    type: 'button',
                    title: 'fetch',
                    allowedClick: ()=> this.allowAddressApiSubmit,
                    onClick: (e) => {
                        let houseNo = document.getElementById(`id_house_no`) ? document.getElementById(`id_house_no`).value : document.getElementById(`id_house_no`);
                        let postCode = document.getElementById(`id_post_code`) ? document.getElementById(`id_post_code`).value : document.getElementById(`id_post_code`);
                        if(!houseNo || !postCode){
                            this.$store.commit('setError', "House Number and Post Code are required")
                            return;
                        }else if( !parseInt(houseNo) ){
                            this.$store.commit('setError', "House Number must be a valid number")
                            return;
                        }
                        this.getAddressDetail(houseNo, postCode)
                    }
                },
                {
                    _id: "reset_auto_address",
                    type: 'button',
                    title: 'Reset',
                    allowedClick: ()=> this.allowAddressReset,
                    onClick: (e) => {
                       this.resetAddressFields();
                    }
                },
            ], 
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading', 'form', 'registration']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        allowAddressApiSubmit() {
            return this.form && this.form.customInfo && 
            (this.form.customInfo.house_no && this.form.customInfo.house_no.value) && 
            (this.form.customInfo.post_code && this.form.customInfo.post_code.value)
        }
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {
        this.toggleComponent();
        
    }, // End of Component > computed
    async updated() {
        this.toggleComponent();
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        resetAddressFields() {
            this.$store.commit('updateField', {
                                         key: 'contactInfo.address',
                                         value: '',
                                     })
            this.$store.commit('updateField', {
                                        key: 'contactInfo.state',
                                        value: '',
                                    })
            this.$store.commit('updateField', {
                                        key: 'contactInfo.city',
                                        value: '',
                                    })
            this.$store.commit('updateField', {
                                        key: 'contactInfo.postalCode',
                                        value: '',
                                    })
                                    
            this.$store.commit('updateField', {
                                        key: 'customInfo.house_no',
                                        value: '',
                                    })
            this.$store.commit('updateField', {
                                        key: 'customInfo.post_code',
                                        value: '',
                                    })
            let addressFieldsIds = this.fields
                .filter((el)=> ['contactInfo.address', 'contactInfo.state', 'contactInfo.city', 'contactInfo.postalCode'].includes(el.key))
                .map((el)=> `id_${el._id}`);
            this.grayOutBackground(addressFieldsIds, true) // revert = true
            this.allowAddressReset = false;

        },
        async getAddressDetail(houseNumber, postCode)
        {
            try {
                this.$store.commit('setLoading', true)
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
                    }
                }
                const postData = {
                    postCode,
                    houseNumber,
                }
                const {data} = await axios.post(apiBaseUrl + 'customers/address-detail', postData, config) 
                if(data.data.result == "Failure"){
                    this.handleGetAddressFailure(data.data);
                    return;
                }
                let streetAddress = '';
                for(let key in  data.data.expandedAddress){
                    if(['house', 'street'].includes(key)){ // keys: house, street, town, county, pCode 
                        streetAddress += `${data.data.expandedAddress[key]}, `
                    }
                }
                streetAddress = streetAddress.slice(0, -2)
                this.$store.commit('updateField', {
                                         key: 'contactInfo.address',
                                         value: streetAddress,
                                     })
                this.$store.commit('updateField', {
                                         key: 'contactInfo.state',
                                         value: data.data.expandedAddress.county,
                                     })
                this.$store.commit('updateField', {
                                         key: 'contactInfo.city',
                                         value: data.data.expandedAddress.town,
                                     })
                this.$store.commit('updateField', {
                                         key: 'contactInfo.postalCode',
                                         value: data.data.expandedAddress.pCode,
                                     })
                let addressFieldsIds = this.fields
                                        .filter((el)=> ['contactInfo.address', 'contactInfo.state', 'contactInfo.city', 'contactInfo.postalCode'].includes(el.key))
                                        .map((el)=> `id_${el._id}`);
                this.grayOutBackground(addressFieldsIds)
                                     
                this.$store.commit('setLoading', false)
                this.allowAddressReset = true
                return true
            } catch(e) {
                console.log('resp error:', e);
                this.handleGetAddressFailure(e.response);
                return false
            }

        },
        handleGetAddressFailure(data) {
            console.log("error data: ",data)
            let errMessage = !data ? 'Something went wrong' : data.errorMsg || data.message; 
            this.$store.commit('setError', errMessage)
            this.$store.commit('setLoading', false)
        },
        grayOutBackground(ids, revert = false) {
            if(Array.isArray(ids)){
                ids.forEach(id=>{
                    let field = document.getElementById(id); 
                    if(field) {
                        field.style.background = revert ? 'none' : 'lightgray'
                        field.readOnly = revert ? false : true;
                    }
                })
            }
        },
        toggleComponent() {
            if(!this.form || !this.checkAddressExists) {
                return;
            }
            console.log("visible: ", !this.form.contactInfo || !this.form.contactInfo.address || !this.form.contactInfo.postalCode || !this.form.contactInfo.state || !this.form.contactInfo.city)
            if(!this.form.contactInfo || !this.form.contactInfo.address || !this.form.contactInfo.postalCode || !this.form.contactInfo.state || (Array.isArray(this.form.contactInfo.state) && this.form.contactInfo.state.length <1 ) || !this.form.contactInfo.city) {
                this.visible = true;
            } else {
                this.visible = false;
                let addressFieldsIds = this.fields
                                            .filter((el)=> ['contactInfo.address', 'contactInfo.state', 'contactInfo.city', 'contactInfo.postalCode'].includes(el.key))
                                            .map((el)=> `id_${el._id}`);
                this.grayOutBackground(addressFieldsIds)
                this.allowAddressReset = true
            }
        }
    }, // End of Component > watch
} // End of export default
</script>
<style scoped>
.row {
    margin-left: 0;
}
.fetchBtn
{
    height: 36px !important;
    font-size: 12px !important;
}
.collapse-link{
    font-weight: bold !important;
    color: var(--primary-color) !important;
}
</style>